export interface Review {
  content: string
  name: string
  partyComposition: string
}

const reviews: Review[] = [
  {
    content: 'Prachtig resort! Erg veilig en kindvriendelijk. Personeel is beleefd en behulpzaam. Aanrader!',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Zeker aan te raden, schoon en goeie ligging',
    name: 'Anushka',
    partyComposition: 'Met familie',
  },
  {
    content: 'Heel ontspannen en rustig',
    name: 'Anoniem',
    partyComposition: 'Alleenstaande ouder',
  },
  {
    content: 'Super goed hotel, zeer vriendelijk personeel en iedere dag alles keurig netjes opgeruimd en schoon',
    name: 'Anoniem',
    partyComposition: 'Alleen',
  },
  {
    content: 'Vriendelijke mensen en goede hygiëne',
    name: 'Peter',
    partyComposition: 'Met partner',
  },
  {
    content: 'Prima en netjes',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Goed',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Prijs kwaliteit verhouding prima',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Mooi hotel vriendelijk personeel',
    name: 'Patrick',
    partyComposition: 'Met partner',
  },
  {
    content: 'Top locatie',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Kom hier vaker, bevalt prima. Top locatie',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'tevreden',
    name: 'Anoniem',
    partyComposition: 'Vrienden',
  },
  {
    content: 'Heel fijn',
    name: 'Ja',
    partyComposition: 'Alleenstaande ouder',
  },
  {
    content: 'Best oke',
    name: 'Anoniem',
    partyComposition: 'Alleen',
  },
  {
    content: 'Prijs kwaliteit goed',
    name: 'Marijke',
    partyComposition: 'Met partner',
  },
  {
    content: 'Goed',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Super hotel',
    name: 'Anoniem',
    partyComposition: 'Vrienden',
  },
  {
    content: 'Komen we zeker nog terug',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Kwalitatief goed',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'perfect in alles',
    name: 'Anoniem',
    partyComposition: 'Vrienden',
  },
  {
    content: 'Top! Niets op aan te merken.',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Top accommodatie, vriendelijk personeel, goede ligging',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Fijne accommodatie, goede schoonmaak, vriendelijk personeel',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Alleen beetje last van mieren maar voor de rest perfect!',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Fijne plek',
    name: 'Sjoukje',
    partyComposition: 'Met partner',
  },
  {
    content: 'Op zich prima.',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Het was een prima accommodatie',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Het is schoon, vriendelijk personeel.',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Goed en zonnig. Heerlijk genoten',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Een fijn hotel',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Geweldige accomodatie!',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'zeer schoon goede service',
    name: 'Fam Tax',
    partyComposition: 'Met partner',
  },
  {
    content: 'Super leuke vakantie gehad',
    name: 'Anoniem',
    partyComposition: 'Met partner',
  },
  {
    content: 'Ligging is prettig',
    name: 'Anoniem',
    partyComposition: 'Alleenstaande ouder',
  },
  {
    content: 'Zeer goed',
    name: 'Wim',
    partyComposition: 'Met partner',
  },
  {
    content: 'Uitstekend.',
    name: 'Ron',
    partyComposition: 'Met partner',
  },
  {
    content: 'Leuk, overzichtelijk, ruimtelijk.',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Vond alles wel prima',
    name: 'William',
    partyComposition: 'Met familie',
  },
  {
    content: 'Zeer positief',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Prima accommodatie',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Accomodatie was super incl het vriendelijke personeel die altijd voor ons klaar stond!',
    name: 'Dirk',
    partyComposition: 'Met familie',
  },
  {
    content: 'Gastvrij en vriendelijk personeel.',
    name: 'A. Jansen',
    partyComposition: 'Met familie',
  },
  {
    content: 'Fantastisch accomodatie',
    name: 'Anoniem',
    partyComposition: 'Alleen',
  },
  {
    content: 'Top! Echte aanrader!',
    name: 'Hans Molenberghs',
    partyComposition: 'Met familie',
  },
  {
    content: 'Voor gezinnen een leuk vakantiepark. Voor ons persoonlijk geen herhaling. Het terras zit aan de voorkant van de woning waardoor je weinig privacy hebt. De slaapbank in de woonkamer is onstabiel en kraakt maar ligt verder prima.',
    name: 'Wilco',
    partyComposition: 'Met Partner',
  },
  {
    content: 'De accommodatie was heel goed. Heel jammer dat er geen diner meer mogelijk was in het hotel, en dat wij dat pas ter plekke merkten. Overigens voor het personeel, met name Nick van de receptie , niks dan lof.',
    name: 'Rina en Maria',
    partyComposition: 'Met Partner',
  },
  {
    content: 'Eenvoudig en simpel hotel, waar hoofdzakelijk Engelse toeristen verblijven. Personeel is uitermate vriendelijk en behulpzaam. Kamers zijn eenvoudig, maar ruim en schoon. Eten was afwisselend en redelijk tot goed.',
    name: 'Jaap van Sintmaartensdijk',
    partyComposition: 'Met Partner',
  },
  {
    content: 'Fijn hotel, goede prijs-/kwaliteit verhouding. Hotelkamers verouderd en sommige zaken aan reparatie toe   (Lekkage douchebak, golvende douchebak, tegels balkon lagen los) maar heb er niet een mindere vakantie om gehad.',
    name: 'Anoniem',
    partyComposition: 'Met Partner',
  },
  {
    content: 'Prima, vriendelijke mensen, behulpzaam bij het invullen wensen. Buffet is wel eentonig met bijv. Bij het ontbijt veel keus uit vleeswaren en kaas maar allemaal niet aantrekkelijk. Dus elke morgen maar weer een. Omelet.',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
  {
    content: 'Mooi complex nette kamers hele goede bedden!! Derde bed in een suite is absoluut niet geschikt voor een volwassene, het hotel loste dit perfect op met een goed matras. Leuk dat er in de avond live muziek was of in andere pub voetbal. Ajax!!',
    name: 'Koen',
    partyComposition: 'Met familie',
  },
  {
    content: 'Super schoon hotel. De kamers waren netjes en schoon. Leuk hotel voor kinderen tot 12 jaar. Het personeel en animatie was erg vriendelijk. Vooral  bij de foodtruck. Die was heel vrolijk en vriendelijk. Elke dag weer.',
    name: 'Anoniem',
    partyComposition: 'Met familie',
  },
]

/**
 * Returns a random review from the reviews array
 */
export function getHeaderReview(): Review {
  const randomIndex = Math.floor(Math.random() * reviews.length)
  return reviews[randomIndex]
}
